import { PaymentsConfig, SiteConfig, SiteMetadata } from "./types";
import { TrackersConfig } from "./lib/tracking-lib/trackers";

export type AppConfig = {
  siteConfig: SiteConfig;
  siteMetadata: SiteMetadata;
  paymentsConfig: PaymentsConfig;
  /** The app's trackers map (src/trackers.ts). */
  trackers: TrackersConfig;
};

let appConfig: AppConfig | undefined;

/**
 * The app injects its brand config here (see src/registerConf.ts, imported
 * first by gatsby-browser.tsx and gatsby-ssr.tsx). Base modules must call the
 * getters at use time — never at module scope, since module evaluation order
 * between the gatsby entry files and page chunks is not guaranteed.
 */
export function registerAppConfig(config: AppConfig): void {
  appConfig = config;
}

function requireAppConfig(): AppConfig {
  if (!appConfig) {
    throw new Error(
      "App config is not registered. Import src/registerConf.ts before any @base module (first import of gatsby-browser.tsx / gatsby-ssr.tsx).",
    );
  }
  return appConfig;
}

export function getSiteConfig(): SiteConfig {
  return requireAppConfig().siteConfig;
}

export function getSiteMetadata(): SiteMetadata {
  return requireAppConfig().siteMetadata;
}

export function getPaymentsConfig(): PaymentsConfig {
  return requireAppConfig().paymentsConfig;
}

export function getTrackers(): TrackersConfig {
  return requireAppConfig().trackers;
}
